// Copyright (c) 2019 Deere & Company
import moment from 'moment';
import React from 'react';

const cellRenderer = params => (
    <a name="claimNumber" data-warrantyClaimId={params.data.id}>
        {params.data.claimNumber}
    </a>
);

const ClaasColumnDefinitions = [
 

        { 
            field: 'claimNumber',
            headerName: 'Claim Number',
            headerTooltip: 'Claim Number',
            sortable: true,
            filter: true,
            width: 150,
            resizable: true,
            pinned: 'left',
            cellRenderer,
        },
        {
            field: 'vehicleSerialNum',
            headerName: 'Vehicle Serial Number',
            headerTooltip: 'Vehicle Serial Number',
            sortable: true,
            filter: true,
            width: 120,
        },
        {
            field: 'engineSerialNum',
            headerName: 'Engine Serial Number',
            headerTooltip: 'Engine Serial Number',
            sortable: true,
            filter: true,
            width: 120,
        },
        {
            field: 'deliveryDate',
            headerName: 'Delivery Date',
            headerTooltip: 'Delivery Date',
            sortable: true,
            filter: true,
            width: 120,
            valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
        },
        {
            field: 'failureDate',
            headerName: 'Failure Date',
            headerTooltip: 'Failure Date',
            sortable: true,
            filter: true,
            width: 120,
            valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
        },
        {
            field: 'processingDate',
            headerName: 'Processing Date',
            headerTooltip: 'Processing Date',
            sortable: true,
            filter: true,
            width: 120,
            valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
        },    
        {
            field: 'partNumber',
            headerName: 'Part Number',
            headerTooltip: 'Part Number',
            sortable: true,
            filter: true,
            width: 120,
        },
        {
            field: 'partDescription',
            headerName: 'Part Description',
            headerTooltip: 'Part Description',
            sortable: true,
            filter: true,
            minWidth: 90,
        },
        {
            field: 'claimType',
            headerName: 'Claim Type',
            headerTooltip: 'Claim Type',
            sortable: true,
            filter: true,
            width: 30
        },
        {
            field: 'countryCode',
            headerName: 'Country Code',
            headerTooltip: 'Country Code',
            sortable: true,
            filter: true,
            width: 20,
        },
        {
            field: 'machineWorkingHours',
            headerName: 'Machine Working Hours',
            headerTooltip: 'Machine Working Hours',
            sortable: true,
            filter: true,
            maxWidth: 250,
        },
        {
            field: 'totalLabourTime',
            headerName: 'Total Labour Time',
            headerTooltip: 'Total Labour Time',
            sortable: true,
            filter: true,
            maxWidth: 150,
        },
        {
            field: 'labourCost',
            headerName: 'Labour Cost (€)',
            headerTooltip: 'Labour Cost (€)',
            sortable: true,
            filter: true,
            maxWidth: 150,
        },
    
        {
            field: 'labourCostUSD',
            headerName: 'Labour Cost ($)',
            headerTooltip: 'Labour Cost ($)',
            sortable: true,
            filter: true,
            maxWidth: 150,
        },
        {
            field: 'partCost',
            headerName: 'Part Cost (€)',
            headerTooltip: 'Part Cost (€)',
            sortable: true,
            filter: true,
            maxWidth: 150,
        },
        {
            field: 'partCostUSD',
            headerName: 'Part Cost ($)',
            headerTooltip: 'Part Cost ($)',
            sortable: true,
            filter: true,
            maxWidth: 150,
        },
        {
            field: 'miscCost',
            headerName: 'Misc Cost (€)',
            headerTooltip: 'Misc Cost (€)',
            sortable: true,
            filter: true,
            maxWidth: 150,
        },
        {
            field: 'miscCostUSD',
            headerName: 'Misc Cost ($)',
            headerTooltip: 'Misc Cost ($)',
            sortable: true,
            filter: true,
            maxWidth: 150,
        },
        {
            field: 'totalCostAccepted',
            headerName: 'Total Cost Accepted (€)',
            headerTooltip: 'Total Cost Accepted (€)',
            sortable: true,
            filter: true,
            maxWidth: 150,
        },
        {
            field: 'totalCostAcceptedUSD',
            headerName: 'Total Cost Accepted ($)',
            headerTooltip: 'Total Cost Accepted ($)',
            sortable: true,
            filter: true,
            maxWidth: 300,
        },
        {
            field: 'partComplaint',
            headerName: 'Part Complaint',
            headerTooltip: 'Part Complaint',
            sortable: true,
            filter: true,
            width: 120,
        },
        {
            field: 'uploadBy',
            headerName: 'Uploaded By',
            headerTooltip: 'Uploaded By',
            sortable: true,
            filter: true,
            maxWidth: 150,
        },
        {
            field: 'updatedBy',
            headerName: 'Updated By',
            headerTooltip: 'Updated By',
            sortable: true,
            filter: true,
            maxWidth: 150,
        },
        {
            field: 'updatedTs',
            headerName: 'Updated Timestamp',
            headerTooltip: 'Updated Timestamp',
            sortable: true,
            filter: true,
            maxWidth: 150,
            valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY HH:mm:ss' ) : '',
        },
        {
            field: 'wrntyLoadTs',
            headerName: 'Warranty Load Timestamp',
            headerTooltip: 'Warranty Load Timestamp',
            sortable: true,
            filter: true,
            maxWidth: 200,
            valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY HH:mm:ss' ) : '',
        },

];
export default ClaasColumnDefinitions;
